import { Col, Input, Label, Row } from 'reactstrap';
import PropTypes from 'prop-types';

const SeccionCentroContacto = ({ formik, formationCenter, userOU, idCedesca, idCntec }) => (
  <Row className="mt-2">
    <Col md="2">
      <Label htmlFor="centro">
        <small>
          Centro <span className="text-danger">*</span>
        </small>
      </Label>
      <Input
        id="centro"
        name="centro"
        type="select"
        onChange={formik.handleChange}
        className={formik.errors.centro ? 'border border-danger error' : ''}
        disabled={(idCedesca > 0 && idCntec > 0) || userOU.centro === 'ORIENTACIÓN'}
        value={formik.values.centro}
      >
        {formationCenter.length > 0
          ? formationCenter.map((option) => (
              <option key={`${option.Id}-centro`} value={option.Id}>
                {option.Nombre}
              </option>
            ))
          : ''}
      </Input>
      {formik.errors.centro ? <div className="text-danger tiny">{formik.errors.centro}</div> : null}
    </Col>
    <Col md="2">
      <Label htmlFor="sexo">
        <small>
          Sexo <span className="text-danger">*</span>
        </small>
      </Label>
      <Input
        id="sexo"
        name="sexo"
        type="select"
        onChange={formik.handleChange}
        value={formik.values.sexo}
        className={formik.errors.sexo ? 'border border-danger error rounded ' : ''}
        disabled={userOU.centro === 'ORIENTACIÓN'}
      >
        <option key="0-sexo" value="0"></option>
        <option key="1-sexo" value="1">
          Hombre
        </option>
        <option key="2-sexo" value="2">
          Mujer
        </option>
        <option key="3-sexo" value="3">
          No binario
        </option>
      </Input>
      {formik.errors.sexo ? <div className="text-danger tiny">{formik.errors.sexo}</div> : null}
    </Col>
    <Col md="3">
      <Label htmlFor="emailPers">
        <small>
          Email <span className="text-danger">*</span>
        </small>
      </Label>
      <Input
        id="emailPers"
        name="emailPers"
        type="email"
        onChange={formik.handleChange}
        value={formik.values.emailPers}
        className={formik.errors.emailPers ? 'border border-danger error' : ''}
        disabled={userOU.centro === 'ORIENTACIÓN'}
      />
      {formik.errors.emailPers ? (
        <div className="text-danger tiny">{formik.errors.emailPers}</div>
      ) : null}
    </Col>
    <Col md="2">
      <Label htmlFor="telefono">
        <small>Teléfono</small>
      </Label>
      <Input
        id="telefono"
        name="telefono"
        type="text"
        onChange={formik.handleChange}
        value={formik.values.telefono}
        className={formik.errors.telefono ? 'border border-danger error' : ''}
        disabled={userOU.centro === 'ORIENTACIÓN'}
      />
      {formik.errors.telefono ? (
        <div className="text-danger tiny">{formik.errors.telefono}</div>
      ) : null}
    </Col>
    <Col md="2">
      <Label htmlFor="movil">
        <small>
          Móvil <span className="text-danger">*</span>
        </small>
      </Label>
      <Input
        id="movil"
        name="movil"
        type="text"
        onChange={formik.handleChange}
        value={formik.values.movil}
        className={formik.errors.movil ? 'border border-danger error' : ''}
        disabled={userOU.centro === 'ORIENTACIÓN'}
      />
      {formik.errors.movil ? <div className="text-danger tiny">{formik.errors.movil}</div> : null}
    </Col>
  </Row>
);

SeccionCentroContacto.propTypes = {
  formik: PropTypes.object.isRequired,
  formationCenter: PropTypes.array,
  userOU: PropTypes.object.isRequired,
  idCedesca: PropTypes.number,
  idCntec: PropTypes.number,
};

export default SeccionCentroContacto;
